import { useEffect, useMemo, useState } from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'

import { getIdToken } from '../../lib/cognito'
import { useAppSelector } from '../../store'

export function RequireNoAuth (): JSX.Element | null {
  let [ searchParams ] = useSearchParams()
  let [ isInitialRender, setIsInitialRender ] = useState(true)
  let [ isValidating, setIsValidating ] = useState(false)

  let [ hasAuth, setHasAuth ] = useState(false)

  let profile = useAppSelector(state => state.auth.profile)

  let sub = profile?.sub
  let previousSub = useMemo(() => window.localStorage.getItem('previous-user'), [])

  let redirectedFrom = '/'

  if (typeof sub === 'string' && sub === previousSub) {
    redirectedFrom = searchParams.get('redirected-from') ?? redirectedFrom
  }

  useEffect(() => {
    setIsValidating(true)

    getIdToken(false)
      .then(() => {
        setHasAuth(true)
      })
      .catch(() => {
        setHasAuth(false)
      })
      .finally(() => {
        setIsValidating(false)
      })
  }, [ profile ])

  useEffect(() => {
    setIsInitialRender(false)
  }, [])

  if (isInitialRender || isValidating) {
    return null
  }

  if (hasAuth) {
    return (
      <Navigate to={redirectedFrom} />
    )
  }

  return (
    <Outlet />
  )
}
